import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { summerFunnelService } from "../../../../summer/services/summerFunnelService"

const initialState = {
    // Funnel state persisted server-side under this id (pre-auth lead capture).
    funnelStateId: null,
    userId: null,
    // Pré-rempli renvoyé par /init (HubSpot hydration) — firstname / email /
    // student_class / student_class_rentree. Le screen classe pioche dedans.
    initUser: null,
    // Snapshot du dernier GET /summer-funnel/{id} (deep link reprise).
    serverState: null,
}

export function summerFunnel(state = initialState, action) {
    switch (action.type) {
        case summerFunnelService.startFunnel.name + apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                funnelStateId:
                    payload.funnel_state_id ??
                    payload.funnelStateId ??
                    state.funnelStateId,
                userId: payload.user_id ?? payload.userId ?? state.userId,
            }
        }

        case summerFunnelService.initFromHubSpot.name + apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                funnelStateId:
                    payload.funnel_state_id ??
                    payload.funnelStateId ??
                    state.funnelStateId,
                initUser: payload.user ?? state.initUser,
            }
        }

        case summerFunnelService.getFunnelState.name + apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                serverState: payload,
            }
        }

        // Reset on logout — required for any user-scoped data.
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        default:
            return state
    }
}

export default summerFunnel
